import {ChangeDetectorRef, Component, Injector, OnInit, TemplateRef, ViewChild, ViewChildren, ViewEncapsulation} from '@angular/core';
import {WarningComponent} from '../../../../../../../shared/components/warning/warning.component';
import {NzModalRef, NzModalService} from 'ng-zorro-antd/modal';
import {CommonService} from '../../../../../../../core/services/common.service';
import {Message} from '../../../../../../../core/class/message';
import {ServiceTypeService} from '../../../../../../../core/services/service-type.service';
import {MatDialog} from '@angular/material';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, Router} from "@angular/router";
import {Subject} from "rxjs";
import {ContractService} from "../../../../../../../core/services/contract.service";
import {ConfigGeneralManageService} from "../../../../../../../core/services/config-general-manage.service";
import _ from 'lodash';
import {NgForm} from "@angular/forms";
import {MatSelect} from '@angular/material/select';
import { ChooseSmsEventDialogComponent,SmsEventRow } from '../../../document/choose-sms-event-dialog/choose-sms-event-dialog.component'

import {
  CdkDrag,
  CdkDropList,
  CdkDropListGroup,
  CdkDragMove,
  moveItemInArray
} from '@angular/cdk/drag-drop';
import {ViewportRuler} from "@angular/cdk/overlay";
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import { ConfigDefaultImageComponent } from '../config-default-image/config-default-image.component';
import { SignDocumentService } from 'src/app/core/services/sign-document.service';
import { DocumentService } from 'src/app/core/services/document.service';

@Component({
  selector: 'app-add-document-group-v2',
  templateUrl: './add-document-group-v2.component.html',
  styleUrls: ['./add-document-group-v2.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddDocumentGroupV2Component implements OnInit {
  isCheckSendSMSCustomerInFlow = false;
  documents = new Document();
  createSuccess = new Subject();
  isFormChanging = false;
  isClickSendSMSInFlow = false;
  isCheckSendSMSInFlow = false;
    isCheckSendEmailInFlow = false;
    isCheckEmailInFlow = true;
    isCheckEmailExpire = false;
    isCheckEmailSign = false;
    isCheckApiSign = false;
    isCheckSMSInFlow = false;
  isCheckSendSMSInternalInFlow = false;
  isOnRemindSignContract = false;
  isCheck = false;
  isClick = false;
  isCheckInternal = false;
  isOtpLimited: boolean = false;
  otpLimitedNumber = '';
  isInvalidMaxMin: boolean = false;
  private checkEscKey: boolean;
  private show: boolean;

  private smsPopupConfigured: { [key: string]: boolean } = {};
  selectedEkyc: any;
  @ViewChild('f', {static: false}) ngForm: NgForm;
  @ViewChildren('focusCode') focusCode;
  @ViewChildren('focusInput') focusInput;
  @ViewChild(CdkDropListGroup, {static: false}) listGroup: CdkDropListGroup<CdkDropList>;
  @ViewChild(CdkDropList, {static: false}) placeholder: CdkDropList;
  @ViewChild(MatSelect, {static: false}) matSelect!: MatSelect;
  tplModal: NzModalRef;
  isDisableEkyc: boolean = false;
  isDisableEkycAdvanced: boolean = false;
  haveConfig: number;

  public listKeyConfig = [{value: null, viewValue: 'timestamp.table_header.type'}]
  public target: CdkDropList;
  public targetIndex: number;
  public source: CdkDropList;
  public sourceIndex: number;
  public dragIndex: number;
  public activeContainer;
  public language: string;

  typeContract = "CONTRACT";


  groupsDTOS: GroupDto[] = [];
  isLoading = false;
  isVerifySubject = true;
  internalFlowNotEdit = false;
  enableSignOneTime = false;
  totalItems = 30;
  isNotAttestedUser: boolean = false;
  isVerifySubjectLoading: boolean = false;
  isVerifySubjectFileLoaded: boolean = false;
  isVerifySubjectInfoLoaded: boolean = false;
  selectedGroupName: any;
  selectedGroup: GroupDto = {};
  selectedGroupId: string = "";
  isRequiredOTP: boolean = false;
  entType = localStorage.getItem('entType')
  isShareMysignEnable = localStorage.getItem('isShareMysignEnable') ? Boolean(localStorage.getItem('isShareMysignEnable')) : false;
  selectedContract : string = "";
  isApplyContractMoha = localStorage.getItem('isApplyContractMoha') === 'true';



  ngAfterViewInit() {
    // Đăng ký ban đầu cho openedChange để xử lý trình nghe sự kiện cuộn
    this.matSelect.openedChange.subscribe(opened => {
      if (opened) {
        const panel = this.matSelect.panel.nativeElement;
        panel.addEventListener('scroll', this.onScroll.bind(this));
      }
    });
  }


  internalObjectsToSendSMS: any[] = [
    {value: '1', viewValue: 'service_type.remind_configuration.objects.signer'},
    {value: '2', viewValue: 'service_type.remind_configuration.objects.approver'},
    {value: '3', viewValue: 'service_type.remind_configuration.objects.initialer'},
    {value: '5', viewValue: 'service_type.remind_configuration.objects.creator'},
  ];
  customerObjectsToSendSMS: any[] = [
    {value: '1', viewValue: 'service_type.remind_configuration.objects.requied_sign'},
    {value: '2', viewValue: 'service_type.remind_configuration.objects.customer_signed'},
    {value: '3', viewValue: 'service_type.remind_configuration.objects.contract_done'},
  ];

  internalObjects: any[] = [
    {value: '1', viewValue: 'search_form.signer'},
    {value: '2', viewValue: 'search_form.approver'},
    {value: '3', viewValue: 'search_form.initialer'},
  ];

  listConfig: any[] = [
    {value: 1, viewValue: 'button.config'},
    {value: 2, viewValue: 'button.individual_config'},
  ];

  listTime: any[] = [
    {value: '', viewValue: 'search_form.format'},
    {
      value: String(new Date().getDate()).padStart(2, '0'),
      viewValue: 'service_type.config_contract_code.time_dd',
      dataSave: 'dd'
    },
    {
      value: String(new Date().getMonth() + 1).padStart(2, '0'),
      viewValue: 'service_type.config_contract_code.time_mm',
      dataSave: 'MM'
    },
    {
      value: String(new Date().getFullYear() % 100),
      viewValue: 'service_type.config_contract_code.time_yy',
      dataSave: 'YY'
    },
    {
      value: String(new Date().getFullYear()),
      viewValue: 'service_type.config_contract_code.time_yyyy',
      dataSave: 'YYYY'
    },
  ];

  listContract: any[] = [
    {value: "LIMITED", viewValue: 'button.limit_contract'},
    {value: "UNLIMITED", viewValue: 'button.unlimit_contract'},
  ];

  listNumber: any[] = [
    {value: '', viewValue: 'search_form.format'},
    {value: '01-99', viewValue: '01-99'},
    {value: '001-999', viewValue: '001-999'},
    {value: '0001-9999', viewValue: '0001-9999'},
    {value: '00001-99999', viewValue: '00001-99999'},
    {value: '000001-999999', viewValue: '000001-999999'},
    {value: '0000001-9999999', viewValue: '0000001-9999999'}
  ];

  previewData = '';
  previewDataDisplay = '';
  selectedComponentType: any = '';
  selectedNumber = {
    value: '',
    viewValue: ''
  };
  selectedTime = {
    value: '',
    viewValue: '',
    dataSave: ''
  };
  selectedCode = '';
  selectedText = '';
  invalidNumber = 0;
  invalidText = false;
  vldMaxlength = '';
  isSubmit = false;
  configAutoNumber: any = {};
  listDataPreview: any[] = [];
  lengthListDataPreview = 0;
  constractCode = '';
  quantityEkycInfo = {
    ekycQuantity: 0,
    advanceEkycQuantity: 0,
    isBoughtEkyc: true,
    isBoughtEkycAdvanced: true
  };

  router: Router;
  message: Message;
  dialog: MatDialog;
  toastr: ToastrService;
  routerActive: ActivatedRoute;
  modalService: NzModalService;
  commonService: CommonService;
  contractService: ContractService;
  serviceTypeService: ServiceTypeService;
  configGeneralManageService: ConfigGeneralManageService;
  isMaxLength: boolean;
  isUpdate: boolean;
  translate: TranslateService;
  serviceTypeId: any = '';

  constructor(
    private injector: Injector,
    private viewportRuler: ViewportRuler,
    private documentService: DocumentService,
    private cdr: ChangeDetectorRef
  ) {
    this.router = injector.get<Router>(Router);
    this.message = injector.get<Message>(Message);
    this.dialog = injector.get<MatDialog>(MatDialog);
    this.toastr = injector.get<ToastrService>(ToastrService);
    this.routerActive = injector.get<ActivatedRoute>(ActivatedRoute);
    this.modalService = injector.get<NzModalService>(NzModalService);
    this.commonService = injector.get<CommonService>(CommonService);
    this.contractService = injector.get<ContractService>(ContractService);
    this.serviceTypeService = injector.get<ServiceTypeService>(ServiceTypeService);
    this.configGeneralManageService = injector.get<ConfigGeneralManageService>(ConfigGeneralManageService);
    this.target = null
    this.source = null
    this.language = localStorage.getItem("__language") || "vi";
    this.translate = injector.get<TranslateService>(TranslateService);
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  ngOnInit() {
    this.constractCode = this.message.getMessage('search_form.service_type_code');
    this.documents.configGeneral = this.documents.configGeneral ? this.documents.configGeneral : 1;
    this.loadNextPage();
    this.documents.notificationServiceTypes = [{
          type: 'IN_FLOW',
          notificationType: 'EMAIL',
          isSendEmailCustomer: true,
          sendEmailInternal: ['1', '2', '3', '5'],
          isActive: true
        }];
        this.documents.isSendSmsSign = false;
        this.documents.isSendSmsExpireContract = false;
        this.documents.isEmploymentContract = false;
    this.getQuantityEkyc();
    this.onFilterData();
    this.onFilterDetail();
    this.getKeyConfig();
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (event.lang) {
        this.transAutoNumber(event.lang);
      }
    });

    if(!this.documents.sendSMSInternalInFlow){
         this.documents.sendSMSInternalInFlow = ['0'];
    }
    if(!this.documents.sendSMSCustomerInFlow){
         this.documents.sendSMSCustomerInFlow = ['0'];
    }

    // this.groupsDTOS = [{name: "Đang tải dữ liệu", groupId: 0, mainIsdn: ""}]
    // const isShareMysignEnable = localStorage.getItem('isShareMysignEnable');
    this.isShareMysignEnable = localStorage.getItem('isShareMysignEnable') == 'true';
    // console.log("isShareMysignEnable", this.isShareMysignEnable);
    // console.log(this.documents);
    this.selectedContract = this.documents.employmentContractTerm;
    
  }
  loadNextPage() {
    if (this.isLoading || this.groupsDTOS.length >= this.totalItems) {
      return;
    }

    this.isLoading = true;
    this.serviceTypeService.getInfoSubCA().subscribe(res => {
      try {
        if (res && res.data) {
          this.totalItems = res.data.sumGroupsDtoCA;

          const groupsDto = res.data.groupsDTOS.map(item => ({
            groupId: ""+ item.groupId,
            isdnMain: item.isdnMain,
            mainIsdn: item.isdnMain,
            name : item.name
          }));
          this.groupsDTOS = groupsDto;
          // localStorage.setItem('groupsDTOS', JSON.stringify(this.groupsDTOS));
        }

      } catch (e) {
        console.log(e);
      }

      this.isLoading = false;
    });
  }

  onScroll() {
    const panel = this.matSelect.panel.nativeElement;
    const scrollTop = panel.scrollTop;
    const scrollHeight = panel.scrollHeight;
    const offsetHeight = panel.offsetHeight;

    if (scrollTop + offsetHeight >= scrollHeight) {
      this.loadNextPage();
    }
  }


  transAutoNumber(lang) {
    let viewCode = '';
    if (lang && lang == 'vi') {
      viewCode = 'Mã loại hợp đồng';
    }
    if (lang && lang == 'en') {
      viewCode = 'Document type code';
    }
    this.constractCode = viewCode;
    if (this.listDataPreview.length) {
      let configAutoNumber = this.getParamConfigAutoNumber(this.listDataPreview);
      this.listDataPreview = this.convertConfigAutoNumber(configAutoNumber, lang)['template'];
      this.displayPreviewData(viewCode);
    }
  }

  dragMoved(e: CdkDragMove) {
    let point = this.getPointerPositionOnPage(e.event);

    this.listGroup._items.forEach(dropList => {
      if (__isInsideDropListClientRect(dropList, point.x, point.y)) {
        this.activeContainer = dropList;
        return;
      }
    });
  }

  dropListDropped() {
    if (!this.target) return;

    let phElement = this.placeholder.element.nativeElement;
    let parent = phElement.parentElement;

    phElement.style.display = "none";

    parent.removeChild(phElement);
    parent.appendChild(phElement);
    parent.insertBefore(
      this.source.element.nativeElement,
      parent.children[this.sourceIndex]
    );

    this.target = null;
    this.source = null;

    if (this.sourceIndex != this.targetIndex)
      moveItemInArray(this.listDataPreview, this.sourceIndex, this.targetIndex);
    this.isFormChanging = true;
    this.convertData();
  }

  dropListEnterPredicate = (drag: CdkDrag, drop: CdkDropList) => {
    if (drop == this.placeholder) return true;

    if (drop != this.activeContainer) return false;

    let phElement = this.placeholder.element.nativeElement;
    let sourceElement = drag.dropContainer.element.nativeElement;
    let dropElement = drop.element.nativeElement;

    let dragIndex = __indexOf(
      dropElement.parentElement.children,
      this.source ? phElement : sourceElement
    );
    let dropIndex = __indexOf(dropElement.parentElement.children, dropElement);

    if (!this.source) {
      this.sourceIndex = dragIndex;
      this.source = drag.dropContainer;

      phElement.style.width = sourceElement.clientWidth + "px";
      phElement.style.height = sourceElement.clientHeight + "px";

      sourceElement.parentElement.removeChild(sourceElement);
    }

    this.targetIndex = dropIndex;
    this.target = drop;

    phElement.style.display = "";
    dropElement.parentElement.insertBefore(
      phElement,
      dropIndex > dragIndex ? dropElement.nextSibling : dropElement
    );
    this.placeholder._dropListRef.enter(
      drag._dragRef,
      drag.element.nativeElement.offsetLeft,
      drag.element.nativeElement.offsetTop
    );

    return false;
  };

  getPointerPositionOnPage(event: MouseEvent | TouchEvent) {
    const point = __isTouchEvent(event)
      ? event.touches[0] || event.changedTouches[0]
      : event;
    const scrollPosition = this.viewportRuler.getViewportScrollPosition();

    return {
      x: point.pageX - scrollPosition.left,
      y: point.pageY - scrollPosition.top
    };
  }

  createTplModal(tplTitle: TemplateRef<{}>, tplContent: TemplateRef<{}>, tplFooter: TemplateRef<{}>, isAutoNumber = false): void {
    this.tplModal = this.modalService.create({
      nzStyle: isAutoNumber ? {top: '20px'} : {},
      nzWidth: isAutoNumber ? '720px' : '520px',
      nzTitle: tplTitle,
      nzContent: tplContent,
      nzFooter: tplFooter,
      nzMaskClosable: true,
      nzClosable: true,
      nzOnOk: () => console.log('Click ok')
    });
  }

  getKeyConfig() {
    this.configGeneralManageService.getAllKeyConfig().subscribe(res => {
      if (res) {
        res.data.filter(element => {
          if (element.typeData === 'AUTO') {
            this.listKeyConfig.push(
              {value: 1, viewValue: 'search_form.component_number'},
              {value: 2, viewValue: 'search_form.component_time'})
          } else if (element.typeData === 'DAY' || element.typeData === 'MONTH' || element.typeData === 'YEAR' || element.typeData === "FULL_YEAR") {
            return;
          } else if (element.typeData === 'SERVICE_TYPE_CODE') {
            this.listKeyConfig.push(
              {value: 3, viewValue: 'search_form.service_type_code'})
          } else if (element.typeData === 'CUSTOMER_INPUT') {
            this.listKeyConfig.push(
              {value: 4, viewValue: 'search_form.component_text'})
          }
        });
      }
    })
  }

  destroyTplModal(): void {
    setTimeout(() => {
      this.tplModal.destroy();
    }, 300);
  }

  onChangeCycleSendSignOrNotifyExpire() {
        this.isFormChanging = true;
    }

  clickChangeSMSConfiguration(data) {
    this.documents.isOnSMSInFlow = data;
    if (this.documents.isOnSMSInFlow === false) {
      this.isFormChanging = true;
      // this.documents.sendSMSInternalInFlow = ['0'];
      // this.documents.isSendCustomerInFlow = false;
      // this.documents.sendSMSCustomerInFlow = ['0'];
    }
  }

  // checkSendSMSCustomerInFlow(): void {
  //   this.isClickSendSMSInFlow = true;
  //   this.documents.isSendCustomerInFlow = !this.documents.isSendCustomerInFlow;
  //   this.isFormChanging = true;
  //   this.isCheckSendSMSInFlow = this.isCheckSendSMSInternalInFlow === true || this.documents.isSendCustomerInFlow === true;
  // }
  checkSendSMSCustomerInFlow(): void {
    this.isClickSendSMSInFlow = true;
    this.isFormChanging = true;
    if (this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.includes('1')) {
    this.documents.sendSMSCustomerInFlow = ['0'];
    this.isCheckSendSMSCustomerInFlow = false;
    this.documents.isSendCustomerInFlow = false;
    
  } else if (this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.includes('0')) {
    this.documents.sendSMSCustomerInFlow = ['1'];
    this.isCheckSendSMSCustomerInFlow = true;
    this.documents.isSendCustomerInFlow = true;
  }
  this.resetSmsPopupConfig('PROCESS', 'customer');
  this.isCheckSendSMSInFlow = this.isCheckSendSMSInternalInFlow === true || this.isCheckSendSMSCustomerInFlow === true;
}
    checkSendMailCustomerInFlow(): void {
      this.isFormChanging = true;
      const dataEmail = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'IN_FLOW');
      if (dataEmail) {
        dataEmail.isSendEmailCustomer = !dataEmail.isSendEmailCustomer;
      } else {
        this.documents.notificationServiceTypes.push({
          type: 'IN_FLOW',
          notificationType: 'EMAIL',
          isSendEmailCustomer: true,
          sendEmailInternal: '',
          isActive: true
        });
      }
    }
    checkSendEmailCustomerInflow() {
        this.isFormChanging = true;
        this.isCheckEmailInFlow = !this.isCheckEmailInFlow;
        this.documents.notificationServiceTypes = this.documents.notificationServiceTypes ?
          this.documents.notificationServiceTypes.filter(data => (data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() !== 'IN_FLOW') || data.notificationType.toUpperCase() === 'API') : [];
        if (this.isCheckEmailInFlow) {
          this.documents.notificationServiceTypes.push({
            type: 'IN_FLOW',
            notificationType: 'EMAIL',
            isSendEmailCustomer: false,
            sendEmailInternal: '',
            isActive: true
          });
        } else {
          this.documents.notificationServiceTypes.push({
            type: 'IN_FLOW',
            notificationType: 'EMAIL',
            isSendEmailCustomer: false,
            sendEmailInternal: '',
            isActive: false
          });
        }
      }

    checkSendEmailCustomerSign(){
      this.isCheck = true;
      this.isFormChanging = true;
      this.isCheckEmailSign = !this.isCheckEmailSign;
      this.documents.notificationServiceTypes = this.documents.notificationServiceTypes ?
        this.documents.notificationServiceTypes.filter(data => (data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() !== 'SIGN') || data.notificationType.toUpperCase() === 'API') : [];
      if (this.isCheckEmailSign) {
        this.documents.notificationServiceTypes.push({
          type: 'SIGN',
          notificationType: 'EMAIL',
          isSendEmailCustomer: this.documents.isSendPromptEmailCustomerSign,
          sendEmailInternal: this.documents.sendPromptEmailInternalSign,
          isActive: true
        });
      } else {
        this.documents.isSendPromptEmailCustomerSign = false;
        this.documents.sendPromptEmailInternalSign = [];
        this.documents.notificationServiceTypes.push({
          type: 'SIGN',
          notificationType: 'EMAIL',
          isSendEmailCustomer: false,
          sendEmailInternal: '',
          isActive: false
        });
      }
    }
    checkSendApiCustomerSign(){
      this.isCheck = true;
      this.isFormChanging = true;
      this.isCheckApiSign = !this.isCheckApiSign;
      this.documents.notificationServiceTypes = this.documents.notificationServiceTypes ?
        this.documents.notificationServiceTypes.filter(data => data.notificationType.toUpperCase() !== 'API') : [];
      if (this.isCheckApiSign) {
        this.documents.notificationServiceTypes.push({
          type: 'SIGN',
          notificationType: 'API',
          isActive: true
        });
      } else {
        this.documents.notificationServiceTypes.push({
          type: 'SIGN',
          notificationType: 'API',
          isActive: false
        });
      }
    }

    checkSendEmailCustomerExpire() {
      this.isFormChanging = true;
      this.isCheckEmailExpire = !this.isCheckEmailExpire;
      this.documents.notificationServiceTypes = this.documents.notificationServiceTypes ? this.documents.notificationServiceTypes.filter(data => (data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() !== 'EXPIRE_CONTRACT') || data.notificationType.toUpperCase() === 'API') : [];
      if (this.isCheckEmailExpire) {
        this.documents.notificationServiceTypes.push({
          type: 'EXPIRE_CONTRACT',
          notificationType: 'EMAIL',
          isActive: true
        });
      } else {
        this.documents.notificationServiceTypes.push({
          type: 'EXPIRE_CONTRACT',
          notificationType: 'EMAIL',
          isActive: false
        });
      }
    }
    checkBoxSendSMSCustomerInflow() {
      this.isFormChanging = true;
      this.isCheckSMSInFlow = !this.isCheckSMSInFlow;
      // console.log("isCheckSMSInFlow", this.isCheckSMSInFlow)
      if (!this.isCheckSMSInFlow) {
        this.documents.isSendCustomerInFlow = false;
        this.documents.sendSMSInternalInFlow = ['0'];
        this.documents.sendSMSCustomerInFlow = ['0'];
        this.isCheckSendSMSInternalInFlow = false;
        this.isCheckSendSMSCustomerInFlow = false;
      }
    }
      getEmailConfig(data): boolean {
        if (!data) return
        const email = data.find(e => e.notificationType.toUpperCase() === 'EMAIL' && e.type.toUpperCase() === 'IN_FLOW');
        if (email && email.isSendEmailCustomer) return email.isSendEmailCustomer;
      }

    checkSendEmailInternalInFlow(): void {
      this.isFormChanging = true;
      const dataEmail = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'IN_FLOW');
      if (this.documents.notificationServiceTypes && dataEmail && dataEmail.sendEmailInternal != '' && dataEmail.sendEmailInternal.length > 0) {
        dataEmail.sendEmailInternal = [];
      } else {
        if(!dataEmail) {
          this.documents.notificationServiceTypes.push({
            type: 'IN_FLOW',
            notificationType: 'EMAIL',
            isSendEmailCustomer: false,
            sendEmailInternal: ['1', '2', '3', '5'],
            isActive: true
          });
        } else {
          dataEmail.sendEmailInternal = ['1', '2', '3', '5'];
        }
      }
      // this.isCheckSendSMSInFlow = this.isCheckSendSMSInternalInFlow === true || this.documents.isSendCustomerInFlow === true;
    }

    checkDisableInFlow(): boolean {
      if (!this.documents.isOnSMSInFlow) {
        return true
      }
      if(this.isCheckSMSInFlow && this.isCheckEmailInFlow){
        return this.checkValObjEmail() && this.checkValObjSMS()
      }
      if(this.isCheckSMSInFlow) {
        return this.checkValObjSMS()
      }
      if(this.isCheckEmailInFlow) {
        return this.checkValObjEmail()
      }
      return false
    }

    checkValObjSMS() {
      return (this.documents.sendSMSInternalInFlow && this.documents.sendSMSInternalInFlow.length > 0) || (this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.length > 0)
    }

    checkValObjEmail() {
      return this.getEmailConfig(this.documents.notificationServiceTypes) || this.checkboxSendEmailInternalInFlow(this.documents.notificationServiceTypes)
    }

    checkDisableSign() {
      if (!this.documents.isOnPromptToSign) {
        return true
      }
      if (!this.isCheckEmailSign && !this.documents.isSendSmsSign) {
        return this.isCheckApiSign;
      } else {
        return true;
      }

    }

    checkDisableExpire() {
      if (!this.documents.isOnNotifyExpireContract) {
        return true
      }

      return this.isCheckEmailExpire || this.documents.isSendSmsExpireContract
    }
    checkValidateEmail(data) {
      if (!data) return
      const email = data.find(e => e.notificationType.toUpperCase() === 'EMAIL' && e.type.toUpperCase() === 'IN_FLOW');
      return email && email.isSendEmailCustomer || (email && email.sendEmailInternal && email.sendEmailInternal.length > 0);
    }

    checkboxSendEmailInternalInFlow(data) {
      if (!data) { return false; }
      const email = data.find(e => e.notificationType.toUpperCase() === 'EMAIL' && e.type.toUpperCase() === 'IN_FLOW');
      if (email && email.sendEmailInternal) {
        return email.sendEmailInternal != '' && email.sendEmailInternal.length > 0;
      } else {
        return false;
      }
    }

    getNoteMesage() {
      return this.message.getMessage('service_type.remind_configuration.note_sms_mail');
    }

    checkEmailInFlow(data) {
      return this.isCheckEmailInFlow;
    }
    checkSMSInFlow(data) {
        return this.isCheckSMSInFlow;
    }


    checkSendSMSInternalInFlow(): void {
      this.isClickSendSMSInFlow = true;
      this.isFormChanging = true;
      if (this.documents.sendSMSInternalInFlow && this.documents.sendSMSInternalInFlow.includes('1')) {
        this.documents.sendSMSInternalInFlow = ['0'];
        this.isCheckSendSMSInternalInFlow = false;
      } else {
        this.documents.sendSMSInternalInFlow = ['1'];
        this.isCheckSendSMSInternalInFlow = true;
      }
      this.resetSmsPopupConfig('PROCESS', 'internal');
      this.isCheckSendSMSInFlow = this.isCheckSendSMSInternalInFlow === true || this.isCheckSendSMSCustomerInFlow === true;
    }

  formChangingCheckSendSMSInternalInFlowEvent() {
    this.isFormChanging = true;
    this.isCheckSendSMSCustomerInFlow = this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.length > 0;
    this.isCheckSendSMSInternalInFlow = this.documents.sendSMSInternalInFlow && this.documents.sendSMSInternalInFlow.length > 0;
    if (this.isCheckSendSMSInternalInFlow || this.documents.isSendCustomerInFlow) {
      this.isCheckSendSMSInFlow = true;
    }
  }
  formChangingCheckSendSMSCustomerInFlowEvent() {
    this.isFormChanging = true;
    this.isCheckSendSMSInternalInFlow = this.documents.sendSMSInternalInFlow && this.documents.sendSMSInternalInFlow.length > 0;
    this.isCheckSendSMSCustomerInFlow = this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.length > 0;
    if (this.isCheckSendSMSInternalInFlow || this.isCheckSendSMSCustomerInFlow) {
      this.isCheckSendSMSInFlow = true;
    }
  }
    formChangingCheckSendEmailInternalInFlowEvent() {
      const sendEmail = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'IN_FLOW');
      this.isFormChanging = true;
      this.isCheckEmailInFlow =
        sendEmail.sendEmailInternal && sendEmail.sendEmailInternal.length > 0;
      if (this.isCheckSendSMSInternalInFlow || this.documents.isSendCustomerInFlow) {
        this.isCheckSendSMSInFlow = true;
      }
    }
    changeValueSign(event: string[]): void {
      const types = this.documents.notificationServiceTypes || [];
      const emailSign = types.find(
        data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'SIGN'
      );
      const selected = event || [];
    
      this.documents.sendPromptEmailInternalSign = selected;   // mảng cho mat-select
      if (emailSign) {
        emailSign.sendEmailInternal = selected;                // mảng, khớp với phần load (đã _.split)
      }
    }
    getIndex(){
      return this.documents.notificationServiceTypes.findIndex((data) => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'IN_FLOW');
    }

    cbxSendEmailInternalInFlow() {
      if(!this.documents.notificationServiceTypes) {
        return
      }
      const emailSign = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'IN_FLOW');
      if (emailSign) return emailSign.sendEmailInternal;
    }

  clickSend(data) {
    this.documents.isOnPromptToSign = data;
    if (this.documents.isOnPromptToSign === false) {
      this.isFormChanging = true;
      // this.documents.isSendSmsSign = false;
      // this.documents.sendInternalSign = ['0'];
      // this.documents.cycleSendSign = 1;
      // this.documents.isSendCustomerSign = false;
      // this.isCheckEmailSign = false;
      // this.isCheckApiSign = false;
    }
  }

  deleteComponent(event) {
    this.listDataPreview = this.listDataPreview.filter(item => {
      return item !== event;
    });
    this.isFormChanging = true;
    this.convertData();
    this.checkNumRangeAlreadyExist();
    // if (!this.invalidNumber) {
    //   this.selectedComponentType = '';
    // }

  }

  onChangeSelectComponent(event, field) {
    this.constractCode = this.message.getMessage('search_form.service_type_code');
    if (field == 'ComponentType') {
      if (!event.value) {
        this.selectedComponentType = '';
      }
      this.selectedText = '';
      this.invalidNumber = 0;
      this.invalidText = false;
      this.selectedNumber = {value: '', viewValue: ''};
      this.selectedTime = {value: '', viewValue: '', dataSave: ''};
      this.listTime = this.listTime.filter(item => !!item.value);
      this.listNumber = this.listNumber.filter(item => !!item.value);
      this.checkNumRangeAlreadyExist();
    }

    if (field == 'numberRange') {
      if (!event.value) {
        this.selectedNumber = {value: '', viewValue: ''};
        this.listNumber = this.listNumber.filter(item => !!item.value);
      }
    }

    if (field == 'time') {
      if (!event.value) {
        this.selectedTime = {value: '', viewValue: '', dataSave: ''};
        this.listTime = this.listTime.filter(item => !!item.value);
      }
    }

  }

  checkNumRangeAlreadyExist() {
    //kiem tra loai dai so da ton tai hay chua
    if (this.selectedComponentType == 1) {
      const vldNumber = [];
      this.listDataPreview.forEach(itemNumber => {
        if (itemNumber.type === 1 && itemNumber.value) {
          vldNumber.push(itemNumber);
        }
      })
      this.invalidNumber = vldNumber.length;
    }
  }

  addSelect(event) {
    this.listNumber = this.listNumber.filter(item => !!item.value);
    this.listTime = this.listTime.filter(item => !!item.value);
    this.listNumber = [{value: '', viewValue: 'search_form.format'}, ...this.listNumber];
    this.listTime = [{value: '', viewValue: 'search_form.format'}, ...this.listTime];
  }

  getLengthContractCode() {
    const listData = [];
    this.listDataPreview.forEach(item => {
      if (item && item.configKey == 'NUMBER_RANGE') {
        listData.push(item.value.toString().split('-')[0])
      } else if (item && (item.configKey == 'SERVICE_TYPE_CODE' || item.configKey == 'CUSTOMER_INPUT')) {
        listData.push(item.configValue ? item.configValue.toString().trim() : '');
      } else if (item && (item.configKey == 'dd' || item.configKey == 'MM' || item.configKey == 'YY' || item.configKey == 'YYYY')) {
        listData.push(item.configKey);
      }
    })
    this.vldMaxlength = listData.join('');
  }

  getMessagevalidateSubmitGroupDocument(vldMaxlength, listDataPreview: any[]) {
    let listError = [];
    if (vldMaxlength.length > 50) {
      listError.push('search_form.contract_code_exceeds_50_characters');
    }
    if (!listDataPreview.filter(x => x.configKey == 'NUMBER_RANGE').length) {
      listError.push('search_form.number_range_required');
    }
    if (listDataPreview.filter(x => x.configKey == 'dd').length && (!listDataPreview.filter(x => x.configKey == 'MM').length || !listDataPreview.filter(x => x.configKey.includes('YY')).length)) {
      listError.push('search_form.date_required_month_and_year');
    }
    if (listDataPreview.filter(x => x.configKey == 'MM').length && !listDataPreview.filter(x => x.configKey.includes('YY')).length) {
      listError.push('search_form.month_required_year');
    }
    return listError;
  }

  saveComponentType() {
    this.isSubmit = true;
    this.getLengthContractCode();
    if (this.vldMaxlength.length > 50) {
      this.toastr.error(this.message.getMessage('search_form.validate_length'));
      return;
    }

    if (this.selectedComponentType == 4 && this.isMaxLength) {
      document.getElementById('selectText').focus();
      this.toastr.error(this.message.getMessage('search_form.validate_length'));
      return;
    }


    switch (this.selectedComponentType) {
      case 1:
        const vldNumber = [];
        this.listDataPreview.forEach(itemNumber => {
          if (itemNumber.type === 1 && itemNumber.value) {
            vldNumber.push(itemNumber);
          }
        })
        this.invalidNumber = vldNumber.length;
        const lengthNum = this.vldMaxlength.length + this.selectedNumber.value.toString().split('-')[0].length;
        if (this.invalidNumber) {
          document.getElementById('selectedComponentType').focus();
          break;
        } else if (lengthNum > 50) {
          this.toastr.error(this.message.getMessage('search_form.validate_length'));
          break;
        } else {
          if (this.selectedNumber.value) {
            this.listDataPreview.push({
              value: this.selectedNumber.value,
              type: 1,
              viewValue: this.message.getMessage('search_form.component_number'),
              configKey: 'NUMBER_RANGE',
              configValue: '',
            });
            break;
          }
        }
        break;
      case 2:
        const vldTime = [];
        this.listDataPreview.forEach(itemNumber => {
          if (itemNumber.type === 2 && itemNumber.value) {
            vldTime.push(itemNumber.value);
          }
        })
        const lengthTime = this.vldMaxlength.length + this.selectedTime.value.length;
        if (lengthTime > 50) {
          this.toastr.error(this.message.getMessage('search_form.validate_length'));
          break;
        } else {
          if (this.selectedTime.value) {
            this.listDataPreview.push({
              value: this.selectedTime.value,
              type: 2,
              viewValue: this.getDisplayTimeValue(this.selectedTime).name,
              displayValue: this.getDisplayTimeValue(this.selectedTime).display,
              configKey: this.getDisplayTimeValue(this.selectedTime).dataSave,
              configValue: '',
            });
            break;
          }
        }
        break;
      case 3:
        const lengthMhd = this.vldMaxlength.split(`[${this.constractCode}]`).join('').length + Number(this.documents.code ? this.documents.code.length : 0);
        if (lengthMhd > 50 || (this.listDataPreview.filter(item => item.value == `[${this.constractCode}]`).length && lengthMhd == 50)) {
          this.toastr.error(this.message.getMessage('search_form.validate_length'));
          break;
        } else {
          if (this.documents.code) {
            this.listDataPreview.push({
              value: this.documents.code,
              type: 3,
              viewValue: this.constractCode,
              configKey: 'SERVICE_TYPE_CODE',
              configValue: this.documents.code,
            });
          } else {
            this.listDataPreview.push({
              value: `[${this.constractCode}]`,
              type: 3,
              viewValue: this.constractCode,
              configKey: 'SERVICE_TYPE_CODE',
              configValue: '',
            });
          }
          break;
        }
      case 4:
        const lengthText = this.vldMaxlength.length + this.selectedText.length;
        if (lengthText > 50) {
          this.toastr.error(this.message.getMessage('search_form.validate_length'));
          document.getElementById('selectText').focus();
          break;
        } else if (this.invalidText) {
          document.getElementById('selectText').focus();
          break;
        } else {
          if (this.selectedText) {
            this.listDataPreview.push({
              value: this.selectedText,
              type: 4,
              viewValue: this.selectedText,
              configKey: 'CUSTOMER_INPUT',
              configValue: this.selectedText,
            });
            break;
          }
        }
        break;
    }
    this.isFormChanging = true;
    this.convertData();
    if (!this.invalidNumber && !this.invalidText) {
      this.selectedComponentType = '';
    }
  }

  getDisplayTimeValue(selectedTime) {
    if (selectedTime.dataSave === 'dd') {
      return {
        name: this.message.getMessage('analysis.analysis_report_consumption.options.day'),
        display: 'DD',
        dataSave: 'dd'
      };
    } else if (selectedTime.dataSave === 'MM') {
      return {
        name: this.message.getMessage('analysis.analysis_report_consumption.options.month'),
        display: 'MM',
        dataSave: 'MM'
      };
    } else if (selectedTime.dataSave === 'YY') {
      return {name: this.message.getMessage('service_type.config_contract_code.year'), display: 'YY', dataSave: 'YY'};
    } else if (selectedTime.dataSave === 'YYYY') {
      return {
        name: this.message.getMessage('service_type.config_contract_code.year'),
        display: 'YYYY',
        dataSave: 'YYYY'
      };
    } else {
      return {name: '', display: '', dataSave: ''};
    }
  }

  convertData() {
    this.listDataPreview.forEach(item => {
      if (item && item.value) {
        if (item.type === 3) {
          item.value = this.documents.code ? this.documents.code : `[${this.constractCode}]`;
          item.configValue = this.documents.code;
        }
      }
    });
    this.getLengthContractCode();
    this.displayPreviewData();
  }

  displayPreviewData(viewCode?: string) {
    const data = [];
    const listDataPreviewCopy = JSON.parse(JSON.stringify(this.listDataPreview));
    listDataPreviewCopy.forEach(item => {
      if (item.type === 1) {
        item.value = item.value.toString().split('-')[0];
      }
      ;
      if (item && item.type === 3 && (item.value === '[Mã loại hợp đồng]' || item.value === '[Document type code]')) {
        if (viewCode) {
          item.value = `<span class="text-danger-code">[${viewCode}]</span>`
        } else {
          item.value = `<span class="text-danger-code">${item.value}</span>`
        }
      } else {
        item.value = `<span class="preview-data">${item.value}</span>`
      }
    });
    listDataPreviewCopy.forEach(item => {
      if (item && item.value) {
        data.push(item.value);
      }
    });
    this.previewDataDisplay = data.join('').trim();
  }

  checkCustomerSms(): void {
    const emailSign = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'SIGN');
      this.isClick = true;
      this.documents.isSendCustomerSign = !this.documents.isSendCustomerSign;
      if (emailSign) {
        emailSign.isSendEmailCustomer = this.documents.isSendCustomerSign;
      }
      // Đổi trạng thái checkbox khách hàng -> popup lần sau tự tích hết
      this.resetSmsPopupConfig('REMINDER', 'customer');
      this.isFormChanging = true;
      this.isCheck = this.isCheckInternal === true || this.documents.isSendCustomerSign === true;
  }

  checkInternalSms(): void {
    this.isClick = true;
    this.isFormChanging = true;
    const emailSign = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'SIGN');
    if (this.documents.sendInternalSign && this.documents.sendInternalSign.includes('1')) {
      this.documents.sendInternalSign = ['0'];
      this.isCheckInternal = false;
    } else {
      this.documents.sendInternalSign = ['1'];
      this.isCheckInternal = true;
    }
    // Đổi trạng thái checkbox nội bộ -> popup lần sau tự tích hết
    this.resetSmsPopupConfig('REMINDER', 'internal');
    this.isCheck = this.isCheckInternal === true || this.documents.isSendCustomerSign === true;
  }

  private resetSmsPopupConfig(functionTypeMode: 'PROCESS' | 'REMINDER' | 'EXPIRY_REMINDER', objectType: 'internal' | 'customer'): void {
    const configKey = this.getConfigArrayKey(functionTypeMode);
    const applyField = objectType === 'internal' ? 'isApplyInternal' : 'isApplyCustomer';
  
    this.smsPopupConfigured[`${configKey}_${objectType}`] = false;
    this.documents[configKey] = (this.documents[configKey] || [])
      .map(c => ({ ...c, [applyField]: false }));
  }

  checkCustomer(): void {
    const emailSign = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'SIGN');
      this.isClick = true;
      this.documents.isSendPromptEmailCustomerSign = !this.documents.isSendPromptEmailCustomerSign;
      if (emailSign) {
        emailSign.isSendEmailCustomer = this.documents.isSendPromptEmailCustomerSign;
      }
      // Đổi trạng thái checkbox khách hàng (luồng nhắc nhở) -> popup lần sau tự tích hết
      this.isFormChanging = true;
      this.isCheck = this.isCheckInternal === true || this.documents.isSendPromptEmailCustomerSign === true;
  }

  checkSmsExpire(): void {
    this.documents.isSendSmsExpireContract = !this.documents.isSendSmsExpireContract;
  
    // Đổi trạng thái checkbox SMS (luồng nhắc hết hạn) -> popup lần sau tự tích hết
    this.resetSmsPopupConfig('EXPIRY_REMINDER', 'internal');
  
    this.isFormChanging = true;
  }

  checkInternal(): void {
      this.isClick = true;
      this.isFormChanging = true;
      const emailSign = this.documents.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'SIGN');
      if (this.documents.sendPromptEmailInternalSign && this.documents.sendPromptEmailInternalSign.length > 0) {
          this.documents.sendPromptEmailInternalSign = [];
          if (emailSign) {
            emailSign.sendEmailInternal = [];
          }
          this.isCheckInternal = false;
      } else {
          this.documents.sendPromptEmailInternalSign = ['1', '2', '3'];
          if (emailSign) {
            emailSign.sendEmailInternal = ['1', '2', '3'];
          }
          this.isCheckInternal = true;
      }
      this.isCheck = this.isCheckInternal === true || this.documents.isSendCustomerSign === true;
  }

  checkoff(){
    const list = this.documents.sendInternalSign;
    if (!list || list.includes('1')) {
      this.documents.sendInternalSign = ['0'];
    }
  
    if (this.documents.isSendCustomerSign) {
      this.documents.isSendCustomerSign = false;
    }
  }

  checkIsErrorRemindEmail(): boolean {
    const raw = this.documents.sendPromptEmailInternalSign;
    const list: string[] = raw ? String(raw).split(',').map(s => s.trim()) : [];
    const isEmpty = list.length === 0 || list.every(s => s === '');
  
    return this.isCheckEmailSign == true
      && this.documents.isSendPromptEmailCustomerSign == false
      && (isEmpty || list.indexOf('0') !== -1);
  }

  formChangingCheckInternalRemindEvent() {
    this.isFormChanging = true;
    this.isCheckInternal = this.documents.sendInternalSign && this.documents.sendInternalSign.length > 0;
    if (this.isCheckInternal || this.documents.isSendCustomerSign) {
      this.isCheck = true;
    }
  }

  clickSendExpire(data) {
    this.documents.isOnNotifyExpireContract = data;
    if (this.documents.isOnNotifyExpireContract === false) {
      this.isFormChanging = true;
      // this.documents.isSendSmsExpireContract = false;
      // this.documents.timeNotifyBeforeExpire = null;
      // this.documents.cycleNotifyExpireContract = null;
      // this.isCheckEmailExpire = false;
    }
  }

  clickSendAutoNumber(event) {
    this.documents.isOnAutoNumber = event;
    this.isFormChanging = true;
    this.selectedComponentType = '';
  }

  createOrEditGroupDocument() {
    if (this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.length > 0) {
      this.documents.isSendCustomerInFlow = true
    } else {
      this.documents.isSendCustomerInFlow = false ;
    }
    if(!this.documents.isEmploymentContract){
      delete this.documents.employmentContractTerm;
    }

    let listError = [];
    listError = this.getMessagevalidateSubmitGroupDocument(this.vldMaxlength, this.listDataPreview);
    if (listError.length && this.documents.isOnAutoNumber) {
      listError.forEach(element => {
        this.toastr.error(this.message.getMessage(element));
      });
      return;
    }
    let _clone = this.checkDataBeforeSave();
    if (this.documents.isOnAutoNumber) {
      let configAutoNumber = this.getParamConfigAutoNumber(this.listDataPreview);
      _clone['configAutoNumber'] = configAutoNumber;
      _clone['isOnAutoNumber'] = true;
    } else {
      _clone['isOnAutoNumber'] = false;
    }
    if(this.documents.configGeneral == 1 || !this.documents.customerImagesConfig.includes('default_image')){
      _clone['defaultImageConfigs'] = null;
    }
    if(_clone['defaultImageConfigs']){
      let isDefault = false;
      _clone['defaultImageConfigs'].forEach(item => {
        isDefault = item.isDefault ? true : isDefault;
      })
      if(!isDefault) _clone['defaultImageConfigs'] = null;
    }

    if (_clone.id) {
      this.serviceTypeService.updateServiceTypes(_clone).subscribe((res) => {
        if (res.success) {
          this.show = false;
          this.toastr.success(this.message.getMessage('messages.update_success'));
          this.router.navigate(['/home-enterprise/document-group-manage']);
          this.createSuccess.next();
        } else {
          if (res.data) {
            if (res.data.field === 'code') {
              this.focusCode.first.nativeElement.focus();
            }
            if (res.data.field === 'name') {
              this.focusInput.first.nativeElement.focus();
            }
          }
          this.toastr.error(res.data ? res.data.error : res.message);
        }
      });
    } else {
      this.serviceTypeService.createServiceTypes(_clone).subscribe((res) => {
        if (res.success) {
          this.show = false;
          this.toastr.success(this.message.getMessage('messages.add_success'));
          this.router.navigate(['/home-enterprise/document-group-manage']);
          this.createSuccess.next();
        } else {
          if (res.data) {
            if (res.data.field === 'code') {
              this.focusCode.first.nativeElement.focus();
            }
            if (res.data.field === 'name') {
              this.focusInput.first.nativeElement.focus();
            }
          }
          this.toastr.error(res.data ? res.data.error : res.message);
        }
      }, error => {
        this.toastr.error(error.message ? error.message : error);
      });
    }
    return false;
  }

  checkDataBeforeSave(): any {
    if (!this.documents.id) {
      if (!this.documents.allowImage) {
        this.documents.allowImage = false;
      }
      if (!this.documents.allowOtp) {
        this.documents.allowOtp = false;
      }
      if (!this.documents.checkCertNumber) {
        this.documents.checkCertNumber = false;
      }
      if (!this.documents.checkName) {
        this.documents.checkName = false;
      }
      if (!this.documents.checkOtp) {
        this.documents.checkOtp = false;
      }
      if (!this.documents.isVerifySubject) {
        this.documents.isVerifySubject = false;
      }
      if (!this.documents.internalFlowNotEdit) {
        this.documents.internalFlowNotEdit = false;
      }
      if (!this.documents.enableSignOneTime ) {
        this.documents.enableSignOneTime = false;
      }
        // Do check for configuration send sms when the contract is processed
      if (!this.documents.isOnSMSInFlow) {
        this.documents.isOnSMSInFlow = false;
      }
      if (!this.documents.sendSMSInternalInFlow) {
        this.documents.sendSMSInternalInFlow = ['0'];
      }
      if (!this.documents.sendSMSCustomerInFlow) {
        this.documents.sendSMSCustomerInFlow = ['0'];
      }
      if (!this.documents.isSendCustomerInFlow) {
        this.documents.isSendCustomerInFlow = false;
      }
      // END Do check for configuration send sms when the contract is processed

      if (!this.documents.isSendSmsSign) {
        this.documents.isSendSmsSign = false;
      }
      if (!this.documents.sendInternalSign) {
        this.documents.sendInternalSign = ['0'];
      }
      if (!this.documents.isSendCustomerSign) {
        this.documents.isSendCustomerSign = false;
      }
      if (!this.documents.isOnPromptToSign) {
        this.documents.isOnPromptToSign = false;
      }
      if (!this.documents.isSendSmsExpireContract) {
        this.documents.isSendSmsExpireContract = false;
      }
      if (!this.documents.isOnNotifyExpireContract) {
        this.documents.isOnNotifyExpireContract = false;
        this.documents.isSendSmsExpireContract = false;
        this.documents.timeNotifyBeforeExpire = null;
        this.documents.cycleNotifyExpireContract = null;
        this.isCheckEmailExpire = false;
      }
    }
    if (this.documents.allowOtp) {
      this.documents.isOtpLimited = this.isOtpLimited;
      this.documents.otpLimitedNumber = this.otpLimitedNumber;
    } else {
      this.documents.isOtpLimited = false;
      this.documents.otpLimitedNumber = '';
    }
    const _clone = JSON.parse(JSON.stringify(this.documents));
    _clone.isVerifySubject = !_clone.isVerifySubject
    if (_clone.sendSMSInternalInFlow && _clone.sendSMSInternalInFlow.length > 0) {
      _clone.sendSMSInternalInFlow = _clone.sendSMSInternalInFlow.join(',');
    }
    if (_clone.sendSMSCustomerInFlow && _clone.sendSMSCustomerInFlow.length > 0) {
      _clone.sendSMSCustomerInFlow = _clone.sendSMSCustomerInFlow.join(',');
    }
        if ((_clone.notificationServiceTypes && _clone.notificationServiceTypes.length > 0)&& this.isCheckEmailInFlow && this.documents.isOnSMSInFlow) {
          const dataEmail = _clone.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'IN_FLOW');
          if (dataEmail && dataEmail.sendEmailInternal && dataEmail.sendEmailInternal.length > 0) {
            dataEmail.sendEmailInternal = dataEmail.sendEmailInternal.join(',');
          }else {
            dataEmail.sendEmailInternal = ''
          }
        } else {
          _clone.notificationServiceTypes = _clone.notificationServiceTypes.filter(data => (data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() !== 'IN_FLOW') || data.notificationType.toUpperCase() === 'API');
        }
        if ((_clone.notificationServiceTypes && _clone.notificationServiceTypes.length > 0) && this.isCheckEmailSign && this.documents.isOnPromptToSign) {
          const dataEmailSign = _clone.notificationServiceTypes.find(data => data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() === 'SIGN');
          if (dataEmailSign && dataEmailSign.sendEmailInternal && dataEmailSign.sendEmailInternal.length > 0) {
            dataEmailSign.sendEmailInternal = dataEmailSign.sendEmailInternal.join(',');
          } else {
            dataEmailSign.sendEmailInternal = ''
          }
        } else {
          _clone.notificationServiceTypes = _clone.notificationServiceTypes.filter(data => (data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() !== 'SIGN') || data.notificationType.toUpperCase() === 'API');
        }
        if ((_clone.notificationServiceTypes && _clone.notificationServiceTypes.length > 0) && !this.isCheckEmailExpire || !this.documents.isOnNotifyExpireContract) {
          _clone.notificationServiceTypes = _clone.notificationServiceTypes.filter(data => (data.notificationType.toUpperCase() === 'EMAIL' && data.type.toUpperCase() !== 'EXPIRE_CONTRACT') || data.notificationType.toUpperCase() === 'API');
        }
    if (_clone.sendInternalSign && _clone.sendInternalSign.length > 0) {
      _clone.sendInternalSign = _clone.sendInternalSign.join(',');
    }
    if (_clone.sendPromptEmailInternalSign && _clone.sendPromptEmailInternalSign.length > 0) {
      _clone.sendPromptEmailInternalSign = _clone.sendPromptEmailInternalSign.join(',');
    } else {
      _clone.sendPromptEmailInternalSign = '';
    }
    if (_clone.id) {
      _clone.updatedTime = new Date();
      _clone.createdTime = new Date(_clone.createdTime);
    }
    if (!this.documents.isOnSMSInFlow) {
      this.isCheckSMSInFlow = false;
      _clone.sendSMSCustomerInFlow = ['0'];
      _clone.sendSMSInternalInFlow = ['0'];
      _clone.processSmsConfigs = [];
      _clone.reminderSmsConfigs = [];
      _clone.notificationServiceTypes = (_clone.notificationServiceTypes || []).filter(function (item) {
        return !(item.notificationType === 'EMAIL' && item.type === 'IN_FLOW');
      });
    }

    if(!this.documents.isOnPromptToSign){
      _clone.isSendPromptEmailCustomerSign = false;
      _clone.sendPromptEmailInternalSign = [];
      this.isCheckEmailSign = false;
      this.isCheckApiSign = false;
      _clone.isSendSmsSign = false;
      _clone.isSendCustomerSign = false;
      _clone.sendInternalSign = ['0'];
      _clone.cycleSendSign = null;

    }
    if(!this.documents.isOnNotifyExpireContract){
      _clone.isSendSmsExpireContract = false;
      _clone.timeNotifyBeforeExpire = null;
      _clone.cycleNotifyExpireContract = null;
    }
    return _clone;
  }

  onBtnCancelClick() {
    if (this.isFormChanging) {
      this.checkEscKey = true;
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.show = false;
          this.router.navigate(['/home-enterprise/document-group-manage']);
        }
        dialogRe.close();
        this.checkEscKey = false;
      });
    } else {
      this.router.navigate(['/home-enterprise/document-group-manage']);
    }
  }
  onClickVerifySubject(){
    if (this.documents.id && this.documents.type == 2) {
      return;
    }
    if (this.documents.isVerifySubject) {
      this.documents.isVerifySubject = false;
      this.isVerifySubjectFileLoaded = false;
      this.isVerifySubjectInfoLoaded = false;
      return;
    }
    this.isFormChanging = true;
    this.isVerifySubjectLoading = true;
    this.isVerifySubjectFileLoaded = false;
    this.isVerifySubjectInfoLoaded = false;
    this.documents.isVerifySubject = false;
    setTimeout(() => {
      this.isVerifySubjectFileLoaded = true;
      this.isVerifySubjectInfoLoaded = true;
      this.documents.isVerifySubject = true;
      this.documents.checkOtp = true;
      this.documents.checkCertNumber = true;
      this.isVerifySubjectLoading = false;
      this.isFormChanging = true;
    }, 500);
  }
  onClickSignInternal(){
    this.isFormChanging = true;
    this.documents.internalFlowNotEdit = !this.documents.internalFlowNotEdit;
  }

  onClickSignOneTime(){
    this.isFormChanging = true;
    this.documents.enableSignOneTime = !this.documents.enableSignOneTime;
    // console.log("asjkdkasjd",this.documents.enableSignOneTime)
  }
  
  onAllowCheckSign(type: string): void {
    this.isFormChanging = true;
    switch (type) {
      case "checkCertNumber":
        this.documents.checkCertNumber = !this.documents.checkCertNumber;
        break;
      case "checkName":
        this.documents.checkName = !this.documents.checkName;
        break;
      case "checkOtp":
        this.documents.checkOtp = !this.documents.checkOtp;
        break;
      case "supportEkyc":
        if (this.documents.ekycSupportConfig === 1) {
          this.documents.ekycSupportConfig = 0;
        } else {
          this.documents.ekycSupportConfig = 1;
        }
        break;
      case "supportEkycAdvanced":
        if (this.documents.ekycSupportConfig === 2) {
          this.documents.ekycSupportConfig = 0;
        } else {
          this.documents.ekycSupportConfig = 2;
        }
        break;
      case "allowOtp":
        this.documents.allowOtp = !this.documents.allowOtp;
        if(this.documents.allowOtp === false) {
          this.isOtpLimited = false;
        }
        if ((this.documents.allowOtp === false) && (this.documents.allowImage === false)) {
          this.documents.ekycSupportConfig = 0;
        }
        break;
      case "allowImage":
        this.documents.allowImage = !this.documents.allowImage;
        if ((this.documents.allowOtp === false) && (this.documents.allowImage === false)) {
          this.documents.ekycSupportConfig = 0;
        }
        break;
      case "generalConfig":
        if (this.documents.configGeneral === 2) {
          this.documents.configGeneral = 1;
        }
        break;
      case "individualConfig":
        if (this.documents.configGeneral === 1) {
          this.documents.configGeneral = 2;
        }
        break;

      case "imageDefault":
          if(this.documents.customerImagesConfig === null || this.documents.customerImagesConfig === undefined) {
            this.documents.customerImagesConfig = [];
          }
          if(this.documents.customerImagesConfig.includes('default_image')) {
            this.documents.customerImagesConfig = this.documents.customerImagesConfig.filter((item) => item !== 'default_image');
          } else {
            this.documents.customerImagesConfig.push('default_image');
          }
          break;

      case "uploadImage":
        if(this.documents.customerImagesConfig === null || this.documents.customerImagesConfig === undefined) {
          this.documents.customerImagesConfig = [];
        }
        if(this.documents.customerImagesConfig.includes('download_sign_image')) {
          this.documents.customerImagesConfig = this.documents.customerImagesConfig.filter((item) => item !== 'download_sign_image');
        } else {
          this.documents.customerImagesConfig.push('download_sign_image');
        }
        break;

      case "drawImage":
        if(this.documents.customerImagesConfig === null || this.documents.customerImagesConfig === undefined) {
          this.documents.customerImagesConfig = [];
        }
        if(this.documents.customerImagesConfig.includes('draw_sign_image')) {
          this.documents.customerImagesConfig = this.documents.customerImagesConfig.filter((item) => item !== 'draw_sign_image');
        } else {
          this.documents.customerImagesConfig.push('draw_sign_image');
        }
        break;
    }
  }

  onAllowSendOTP() {
    this.isFormChanging = true;
    this.isOtpLimited = !this.isOtpLimited;
  }

  offAllowCheckSign(){
    this.documents.allowOtp = false;
    this.selectedContract = "";
    this.isOtpLimited = false;
    this.otpLimitedNumber= '';
    this.documents.ekycSupportConfig = null;
    this.documents.checkCertNumber = true;
    this.otpLimitedNumber= '';
  }

  getQuantityEkyc() {
    this.contractService.getDataCountNumberDocumentOfEnterpriseByService().subscribe(res => {
      if (Object.keys(res.data).length !== 0 && res.data.constructor === Object) {
        //Lấy số lượng ký ekyc và ekyc nâng cao: số lượng >=0 -> đã mua, số lượng undefined -> chưa mua
        if (res.data.ekycQuantity !== undefined) {
          this.quantityEkycInfo.ekycQuantity = res.data.ekycQuantity;
        } else {
          this.quantityEkycInfo.isBoughtEkyc = false;
        }

        if (res.data.advanceEkycQuantity !== undefined) {
          this.quantityEkycInfo.advanceEkycQuantity = res.data.advanceEkycQuantity;
        } else {
          this.quantityEkycInfo.isBoughtEkycAdvanced = false;
        }
      }
      this.getIsDisabledEkyc(this.quantityEkycInfo);
    })
  }

  getIsDisabledEkyc(quantityEkycInfo: any): void {
    if (!quantityEkycInfo.isBoughtEkyc) {
      this.isDisableEkyc = true;
    }
    if (!quantityEkycInfo.isBoughtEkycAdvanced) {
      this.isDisableEkycAdvanced = true;
    }
  }

  onFilterData() {
    this.configGeneralManageService.filterConfigGeneral().subscribe((res) => {
      if (res.success) {
        if (res.data != null) {
          this.haveConfig = 1;
        } else {
          this.haveConfig = 0;
        }
      }
    })
  }

  onFilterDetail() {
    this.routerActive.queryParams.subscribe(params => {
      if (params["serviceTypeId"]) {
        this.serviceTypeId = params["serviceTypeId"]
        this.serviceTypeService.getServiceTypeById(params["serviceTypeId"]).subscribe(res => {
          //('res getServiceTypeById',res.data);
          if (res.success && res.data != null) {
            // console.log(res.data);
            if (res.data.employmentContractTerm){
            this.selectedContract = res.data.employmentContractTerm;
            }
            if ((res.data.sendSMSInternalInFlow && (res.data.sendSMSInternalInFlow.includes('1') 
                                                                || res.data.sendSMSInternalInFlow.includes('2')
                                                                || res.data.sendSMSInternalInFlow.includes('3')
                                                                || res.data.sendSMSInternalInFlow.includes('5'))) 
                    || (res.data.sendSMSCustomerInFlow && (res.data.sendSMSCustomerInFlow.includes('1')
                                                                 || res.data.sendSMSCustomerInFlow.includes('2')
                                                                 || res.data.sendSMSCustomerInFlow.includes('3') )) ) {
                      this.isCheckSMSInFlow = true;
                    }
            if (res.data.isOnPromptToSign) {
              this.isOnRemindSignContract = true;
            }

            //sms tien trinh - noi bo
              if (res.data.sendSMSInternalInFlow) {
               const values = _.split(res.data.sendSMSInternalInFlow, ',');
               const hasTarget = values.some(v => ['1', '2', '3', '5'].includes(v.trim()));
                res.data.sendSMSInternalInFlow = hasTarget ? ['1'] : values;
              }

            if (!res.data.sendSMSInternalInFlow) {
              res.data.sendSMSInternalInFlow = ['0'];
            }

            //sms tien trinh - noi bo
            if (res.data.sendSMSCustomerInFlow) {
              const values = _.split(res.data.sendSMSCustomerInFlow, ',');
              const hasTarget = values.some(v => ['1', '2', '3', '5'].includes(v.trim()));
              res.data.sendSMSCustomerInFlow = hasTarget ? ['1'] : values;
            }

            if (!res.data.sendSMSCustomerInFlow) {
              res.data.sendSMSCustomerInFlow = ['0'];
            }
            
            //sms - nhac xu ly - noi bo
            if (res.data.sendInternalSign) {
              const values = _.split(res.data.sendInternalSign, ',');
              const hasTarget = values.some(v => ['1', '2', '3', '5'].includes(v.trim()));
              res.data.sendInternalSign = hasTarget ? ['1'] : values;
            }

            if (!res.data.sendInternalSign) {
              res.data.sendInternalSign = ['0'];
            }

            if (res.data.sendPromptEmailInternalSign) {
              res.data.sendPromptEmailInternalSign = _.split(res.data.sendPromptEmailInternalSign, ',');
            }
            this.documents = res.data;
            this.isOtpLimited = this.documents.isOtpLimited ? this.documents.isOtpLimited : false;
            this.otpLimitedNumber = this.documents.otpLimitedNumber ? this.documents.otpLimitedNumber : '';
            this.documents.isVerifySubject = !this.documents.isVerifySubject;
            if(this.documents.isVerifySubject == true){
              this.documents.checkCertNumber = true;
              this.documents.checkOtp = true;
            }
            if(this.documents.customerImagesConfig == null) {
              this.documents.customerImagesConfig = ['default_image', 'download_sign_image', 'draw_sign_image'];
            } else {
              this.documents.customerImagesConfig = res.data.customerImagesConfig;
            }

            if(res.data.isEmploymentContract){
              this.documents.checkCertNumber = true;
            }

            if(res.data.isSendCustomerInFlow && (res.data.sendSMSCustomerInFlow.length == 0 ||res.data.sendSMSCustomerInFlow=="" )) {
              this.documents.sendSMSCustomerInFlow =  ['0'];
            }
            // nếu có group
            if (this.documents.groupName) {
              const metadata: GroupDto = JSON.parse(this.documents.metaData);
              // const selectGroup = {
              //   name: this.documents.groupName,
              //   isdnMain: metadata.isdnMain,F
              //   mainIsdn: metadata.mainIsdn,
              //   groupId: metadata.groupId
              // };
              // console.log(this.groupsDTOS)
              // this.groupsDTOS = [selectGroup];

              // this.selectedGroup = selectGroup;
              this.selectedGroupId = "" + metadata.groupId;
            }
            this.isCheckSendSMSInternalInFlow = this.documents.sendSMSInternalInFlow && this.documents.sendSMSInternalInFlow.length > 0;
            this.isCheckSendSMSCustomerInFlow = this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.length > 0;
            if (this.isCheckSendSMSInternalInFlow || this.isCheckSendSMSCustomerInFlow) {
              this.isCheckSendSMSInFlow = true;
            }


            this.isCheckInternal = this.documents.sendInternalSign && (this.documents.sendInternalSign.includes('1') || this.documents.sendInternalSign.includes('2') || this.documents.sendInternalSign.includes('3'));
                    if (this.isCheckInternal || this.documents.isSendCustomerSign) {
                        this.isCheck = true;
                    }
            this.documents.isOnAutoNumber = res.data.isOnAutoNumber;
                        if(!this.documents.notificationServiceTypes.length) {
                          this.documents.isOnSMSInFlow = true
                          this.documents.notificationServiceTypes =
                            [
                              {
                              type: 'IN_FLOW',
                              notificationType: 'EMAIL',
                              isSendEmailCustomer: true,
                              sendEmailInternal: ['1', '2', '3', '5'],
                              isActive: true
                              },
                              {
                                type: 'SIGN',
                                notificationType: 'EMAIL',
                                isSendEmailCustomer: this.documents.isSendCustomerSign,
                                sendEmailInternal: this.documents.sendInternalSign,
                                isActive: true
                              },
                              {
                                type: 'EXPIRE_CONTRACT',
                                notificationType: 'EMAIL',
                                isActive: true
                              },
                              {
                                type: 'SIGN',
                                notificationType: 'API',
                                isActive: true
                              }
                            ];
                          }
                        const checkEmail = this.documents.notificationServiceTypes.find(email => email.notificationType.toUpperCase() === 'EMAIL' && email.type.toUpperCase() === 'IN_FLOW');
                        if (checkEmail && checkEmail.isActive) {
                          checkEmail.sendEmailInternal = _.split(checkEmail.sendEmailInternal, ',');
                          this.isCheckEmailInFlow = true;
                        } else {
                          this.isCheckEmailInFlow = false;
                        }
                        const checkEmailSign = this.documents.notificationServiceTypes.find(email => email.notificationType.toUpperCase() === 'EMAIL' && email.type.toUpperCase() === 'SIGN');
                        if (checkEmailSign && checkEmailSign.isActive) {
                          checkEmailSign.sendEmailInternal = _.split(checkEmailSign.sendEmailInternal, ',');
                          this.isCheckEmailSign = true;
                        }
                        const checkEmailExpire = this.documents.notificationServiceTypes.find(email => email.notificationType.toUpperCase() === 'EMAIL' && email.type.toUpperCase() === 'EXPIRE_CONTRACT');
                        if (checkEmailExpire && checkEmailExpire.isActive) {
                          this.isCheckEmailExpire = true;
                        }
                        const checkApiSign = this.documents.notificationServiceTypes.find(api => api.notificationType.toUpperCase() === 'API' && api.type.toUpperCase() === 'SIGN');
                        if (checkApiSign && checkApiSign.isActive) {
                          this.isCheckApiSign = true;
                        }
            if (res.data.configAutoNumber && Object.keys(res.data.configAutoNumber).length) {
              this.configAutoNumber = res.data.configAutoNumber;
              this.listDataPreview = this.convertConfigAutoNumber(this.configAutoNumber)['template'];
              if (this.configAutoNumber && this.listDataPreview.length > 0) {
                this.isUpdate = true
              }

              this.getLengthContractCode();
              this.displayPreviewData();
              
            }
          }
        });
      } else {
        this.documents.customerImagesConfig = ['default_image', 'download_sign_image', 'draw_sign_image'];
      }
    })
  }

  getParamConfigAutoNumber(data) {
    const configAutoNumber = {};
    configAutoNumber['template'] = data.map((item, index) => {
      return {
        order: index + 1,
        configKey: item.configKey,
        configValue: item.configValue ? item.configValue : ''
      }
    });
    const numberRangeObj = data.find(item => item.configKey === 'NUMBER_RANGE');
    configAutoNumber['fromNumber'] = numberRangeObj.value.split('-')[0];
    configAutoNumber['toNumber'] = numberRangeObj.value.split('-')[1];
    return configAutoNumber;
  }

  convertConfigAutoNumber(dataApi: any, lang?: string) {
    let dataApiCopy = [];
    let viewNum = '', viewCode = '', viewDd = '', viewMm = '', viewYy = '';
    if (lang && lang == 'vi') {
      viewNum = 'Dải số';
      viewCode = 'Mã loại hợp đồng';
      viewDd = 'Ngày'
      viewMm = 'Tháng';
      viewYy = 'Năm';
    }
    if (lang && lang == 'en') {
      viewNum = 'Number range';
      viewCode = 'Document type code';
      viewDd = 'Day'
      viewMm = 'Month';
      viewYy = 'Year';
    }
    dataApiCopy = JSON.parse(JSON.stringify(dataApi));
    dataApiCopy['template'].sort((a, b) => a.order - b.order);
    dataApiCopy['template'].forEach(item => {
      if (item.configKey === 'NUMBER_RANGE') {
        item.value = dataApi.fromNumber + '-' + dataApi.toNumber,
          item.type = 1,
          item.viewValue = this.message.getMessage('search_form.component_number') ? this.message.getMessage('search_form.component_number') : viewNum
      }
      if (item.configKey === 'SERVICE_TYPE_CODE') {
        if (lang) {
          item.value = item.configValue ? item.configValue : `[${viewCode}]`;
        } else {
          item.value = item.configValue;
        }
        item.type = 3,
          item.viewValue = this.message.getMessage('search_form.service_type_code') ? this.message.getMessage('search_form.service_type_code') : viewCode
      }
      if (item.configKey === 'dd') {
        item.value = String(new Date().getDate()).padStart(2, '0'),
          item.type = 2,
          item.viewValue = this.message.getMessage('analysis.analysis_report_consumption.options.day') ? this.message.getMessage('analysis.analysis_report_consumption.options.day') : viewDd,
          item.displayValue = "DD"
      }
      if (item.configKey === 'MM') {
        item.value = String(new Date().getMonth() + 1).padStart(2, '0'),
          item.type = 2,
          item.viewValue = this.message.getMessage('analysis.analysis_report_consumption.options.month') ? this.message.getMessage('analysis.analysis_report_consumption.options.month') : viewMm,
          item.displayValue = "MM"
      }
      if (item.configKey === 'YY') {
        item.value = String(new Date().getFullYear() % 100),
          item.type = 2,
          item.viewValue = this.message.getMessage('service_type.config_contract_code.year') ? this.message.getMessage('service_type.config_contract_code.year') : viewYy,
          item.displayValue = "YY"
      }
      if (item.configKey === 'YYYY') {
        item.value = String(new Date().getFullYear()),
          item.type = 2,
          item.viewValue = this.message.getMessage('service_type.config_contract_code.year') ? this.message.getMessage('service_type.config_contract_code.year') : viewYy,
          item.displayValue = "YYYY"
      }
      if (item.configKey === 'CUSTOMER_INPUT') {
        item.value = item.configValue,
          item.type = 4,
          item.viewValue = item.configValue
      }
    })
    return dataApiCopy;
  }

  onChangeFormInput(field?: string) {
    this.invalidText = false;
    this.isSubmit = false;
    this.isFormChanging = true;
    this.isCheck = true;
    if (field === 'code') {
      this.convertData();
    }
    if (field === 'free_text') {
      if (this.hasSpaces(this.selectedText.trim())) {
        this.invalidText = true;
      } else {
        this.invalidText = false;
      }

      if (this.selectedText.length > 50) {
        this.isMaxLength = true
      } else {
        this.isMaxLength = false
      }
    }
  }

  onChangeotpLimited() {
    console.log(this.otpLimitedNumber);
  }

  hasSpaces(str) {
    return / /.test(str);
  }

  getToolTipMaxLength30(value) {
    return value.toString().length > 30 ? value : '';
  }


  onChange(event: any) {
    const selectItem = this.groupsDTOS.filter(item=>{
     return "" + item.groupId == this.selectedGroupId;
    });

    if(selectItem.length <=0){
      return;
    }

    this.documents.groupName = selectItem[0].name;
    this.documents.metaData = JSON.stringify({
      groupId: "" + selectItem[0].groupId,
      mainIsdn: selectItem[0].isdnMain
    });
    this.isFormChanging = true;
  }

  clearData() {
    this.documents.groupName = null;
    this.documents.metaData = null;
    this.selectedGroup = {};
    this.isFormChanging = true;
    this.selectedGroupId = "";

  }

  isShowClearButton() {
    return !!this.documents.groupName;
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  checkSignOneTurn(){
    if(Number(this.entType) == 1){
      if(this.documents.isEmploymentContract){
          return true;
      }else{
          return false;
      }
    }else if(Number(this.entType) == 2){
          return true;
    }
  }


normalizeValue(event: FocusEvent): void {
  const inputElement = event.target as HTMLInputElement;
  let value = inputElement.value;

  // Xóa các số 0 không cần thiết ở đầu
  if (value) {
    if (value.includes('.')) {
      // Số thập phân: Chuẩn hóa phần nguyên
      const [integerPart, decimalPart] = value.split('.');
      value = parseInt(integerPart || '0', 10) + '.' + (decimalPart || '');
    } else {
      // Số nguyên: Chuyển thành số bình thường
      value = parseInt(value, 10).toString();
    }
  }
  inputElement.value = value;
  this.otpLimitedNumber = value;
}

changeValue(value: any) {
  // console.log(value);

  this.isFormChanging = true;
  if (!(Number(this.otpLimitedNumber) > 0 && Number(this.otpLimitedNumber) < 101)) {
    this.isInvalidMaxMin = true;
  } else {
    this.isInvalidMaxMin = false;
  }
  this.cdr.detectChanges();
}


  checkDisable() {
    const a1 = !this.isFormChanging || (this.documents.isOnAutoNumber && !this.listDataPreview)
    const a2 = this.documents.configGeneral === 1
    const a3 = ((!this.isFormChanging || (!this.isCheck && this.documents.isOnPromptToSign)
    || !this.checkDisableInFlow()
          || !this.checkDisableSign()
          || !this.checkDisableExpire()
          || (this.documents.timeNotifyBeforeExpire == null && this.documents.isOnNotifyExpireContract)) && this.documents.configGeneral === 2);
          const a4 = (this.documents && this.documents.customerImagesConfig && !this.documents.customerImagesConfig.length)
  }

  configDefaultImage(){
    const dialogRe = this.dialog.open(ConfigDefaultImageComponent, {
      width: "80vh",
      data: (this.documents.defaultImageConfigs && this.documents.defaultImageConfigs.length > 0) ? this.documents.defaultImageConfigs : null,
    })

    dialogRe.afterClosed().subscribe(result => {
      if(result){
        this.documents.defaultImageConfigs = result;
        this.changeValue(result)
      }
    })
  } 

  checkIsErrorProcess(): boolean {
  const sendSMSInternalInFlow = this.documents.sendSMSInternalInFlow && this.documents.sendSMSInternalInFlow.length > 0
    ? this.documents.sendSMSInternalInFlow
    : ['0'];
  const sendSMSCustomerInFlow = this.documents.sendSMSCustomerInFlow && this.documents.sendSMSCustomerInFlow.length > 0
    ? this.documents.sendSMSCustomerInFlow
    : ['0'];

  if(this.isCheckSMSInFlow && !this.documents.isOnSMSInFlow){
    return false;
  }

  if (sendSMSInternalInFlow.includes('0') && sendSMSCustomerInFlow.includes('0') && this.isCheckSMSInFlow) {
    return true;
  } else {
    return false;
  }
}


  checkIsErrorRemind(): boolean {
  const sendInternalSign = this.documents.sendInternalSign && this.documents.sendInternalSign.length > 0
    ? this.documents.sendInternalSign
    : ['0'];

    if(this.documents.isSendSmsSign && !this.documents.isOnPromptToSign){
    return false;
  }

  if (this.documents.isSendCustomerSign == false && sendInternalSign.includes('0') && this.documents.isSendSmsSign == true) {
    return true;
  } else {
    return false;
  }
}

  remindSmsChange(){
    this.isFormChanging = true;
    this.documents.isSendCustomerSign = false;
  }

  chonSuKienGuiSMS(objectType: 'internal' | 'customer', functionTypeMode: 'PROCESS' | 'REMINDER' | 'EXPIRY_REMINDER'): void {
    const configKey = this.getConfigArrayKey(functionTypeMode);
    const existingConfigs = this.documents[configKey] || [];
  
    const applyField = objectType === 'internal' ? 'isApplyInternal' : 'isApplyCustomer';
    const currentSelected = existingConfigs
      .filter(c => c[applyField])
      .map(c => c.smsTemplateCode);
  
    // Đã cấu hình khi: có dòng được chọn từ trước, hoặc người dùng đã từng lưu popup này.
    // Chưa cấu hình (hoặc vừa đổi trạng thái checkbox) -> popup tự tích chọn tất cả.
    const flagKey = `${configKey}_${objectType}`;
    const isConfigured = currentSelected.length > 0 || !!this.smsPopupConfigured[flagKey];
  
    if (this.entType === '2') {
      this.typeContract = "CONTRACT";
    } else if (this.entType === '1') {
      this.typeContract = "CONTRACT";
    }
    let type = '3';
    if (objectType === 'internal') {
      type = '1';
    } else if (objectType === 'customer') {
      type = '2';
    }
  
    const dialogRef = this.dialog.open(ChooseSmsEventDialogComponent, {
      width: '1100px',
      maxHeight: '90vh',
      data: {
        objectType,
        businessType: this.typeContract,
        applyType: type,
        currentSelected,
        functionType: functionTypeMode,
        isConfigured
      }
    });
  
    dialogRef.afterClosed().subscribe((result: { rows: SmsEventRow[]; changed: boolean } | null) => {
      if (result && result.rows) {
        this.documents[configKey] = this.mergeSmsConfigs(existingConfigs, result.rows, objectType, configKey);
  
        // Đã lưu popup: lần sau mở lại phải theo dữ liệu, kể cả khi không chọn dòng nào
        this.smsPopupConfigured[flagKey] = true;
  
        // rows giờ chứa cả true và false nên phải kiểm tra theo selected
        if (!result.rows.some(r => r.selected)) {
          this.uncheckSendSmsInFlowFlag(objectType, functionTypeMode);
        }
        // Có thay đổi sự kiện SMS trong popup -> bật sáng nút Lưu
        if (result.changed) {
          this.isFormChanging = true;
        }
      }
    });
  }

  private uncheckSendSmsInFlowFlag(
    objectType: 'internal' | 'customer',
    functionTypeMode: 'PROCESS' | 'REMINDER' | 'EXPIRY_REMINDER'
  ): void {
    const isOn = (arr: string[] | undefined | null): boolean => !!arr && arr.includes('1');

    if (functionTypeMode === 'PROCESS') {
      if (objectType === 'internal' && isOn(this.documents.sendSMSInternalInFlow)) {
        this.checkSendSMSInternalInFlow();
      } else if (objectType === 'customer' && isOn(this.documents.sendSMSCustomerInFlow)) {
        this.checkSendSMSCustomerInFlow();
      }
    } else if (functionTypeMode === 'REMINDER') {
      if (objectType === 'internal' && isOn(this.documents.sendInternalSign)) {
        this.checkInternalSms();
      } else if (objectType === 'customer' && this.documents.isSendCustomerSign) {
        this.checkCustomerSms();
      }
    } else if (functionTypeMode === 'EXPIRY_REMINDER') {
      // Tab này chỉ có 1 checkbox SMS duy nhất, không tách nội bộ/khách hàng,
      // được toggle trực tiếp trong template (không qua hàm riêng)
      if (this.documents.isSendSmsExpireContract) {
        this.documents.isSendSmsExpireContract = false;
      }
    }
  }

  private mergeSmsConfigs(existingConfigs: any[], selectedResult: SmsEventRow[], objectType: 'internal' | 'customer', configKey: string): any[] {
    // Chỉ những dòng selected = true mới được tính là đã chọn
    const selectedCodes = selectedResult.filter(r => r.selected).map(r => r.code);
    const configs = existingConfigs.map(cfg => ({ ...cfg }));
  
    if (configKey === 'expirySmsConfigs') {
      // Mảng này chỉ phục vụ nội bộ, không có isApplyCustomer
      return selectedResult.map(item => ({
        smsTemplateId: (item as any).smsTemplateId || (item as any).id,
        smsTemplateCode: item.code,
        isApplyInternal: item.selected
      }));
    }
  
    const applyField = objectType === 'internal' ? 'isApplyInternal' : 'isApplyCustomer';
  
    // Cập nhật lại flag cho các entry đã có sẵn
    configs.forEach(cfg => {
      cfg[applyField] = selectedCodes.includes(cfg.smsTemplateCode);
    });
  
    // Thêm mới các entry chưa tồn tại trong mảng (kể cả dòng không chọn, flag = false)
    selectedResult.forEach(item => {
      const exist = configs.find(cfg => cfg.smsTemplateCode === item.code);
      if (!exist) {
        configs.push({
          smsTemplateId: (item as any).smsTemplateId || (item as any).id,
          smsTemplateCode: item.code,
          isApplyCustomer: objectType === 'customer' && item.selected,
          isApplyInternal: objectType === 'internal' && item.selected
        });
      }
    });
  
    // Giữ cả entry có flag false (danh sách có cả true và false)
    return configs;
  }
  
  private getConfigArrayKey(functionTypeMode: string): 'processSmsConfigs' | 'reminderSmsConfigs' | 'expirySmsConfigs' {
    switch (functionTypeMode) {
      case 'PROCESS': return 'processSmsConfigs';
      case 'REMINDER': return 'reminderSmsConfigs';
      case 'EXPIRY_REMINDER': return 'expirySmsConfigs';
      default: return 'processSmsConfigs';
    }
  }
  
  onContractChange(event?: any){
    this.documents.employmentContractTerm = this.selectedContract;

  }

}

export class Document {
  id: number;
  name: string;
  note: string;
  code: string;
  groupName: string;
  metaData: string;
  allowOtp: boolean = false;
  allowImage: boolean = false;
  checkCertNumber: boolean = false;
  checkName: boolean = false;
  checkOtp: boolean = false;
  isSendSmsSign: boolean;
  sendInternalSign: any;
  isSendCustomerSign: boolean;
  cycleSendSign: number;
  isOnPromptToSign = false;
  isOnNotifyExpireContract: boolean;
  isSendSmsExpireContract: boolean;
  isOnAutoNumber: boolean;
  timeNotifyBeforeExpire: number;
  cycleNotifyExpireContract: number;
  isOnSMSInFlow = true;
  sendSMSInternalInFlow: any;
  isSendCustomerInFlow: boolean;
  ekycSupportConfig: number;
  configGeneral: number;
  type: number;
  notificationServiceTypes: any[];
  customerImagesConfig: string[];
  sendSMSCustomerInFlow: any;
  isVerifySubject = false;
  internalFlowNotEdit = false;
  isOtpLimited: boolean;
  otpLimitedNumber: any;
  enableSignOneTime: boolean = false;
  defaultImageConfigs: any[] = null;
  isEmploymentContract: boolean = false;
  employmentContractTerm: string = "";
  processSmsConfigs: any;
  reminderSmsConfigs: any;
  expirySmsConfigs: any;
  isSendPromptEmailCustomerSign: boolean;
  sendPromptEmailInternalSign: any;
}

export class GroupDto {
  code?: string;
  groupId?: number;
  isdnMain?: string;
  mainIsdn?: string;
  name?: string;

}

function __indexOf(collection, node) {
  return Array.prototype.indexOf.call(collection, node);
}

function __isTouchEvent(event: MouseEvent | TouchEvent): event is TouchEvent {
  return event.type.startsWith("touch");
}

function __isInsideDropListClientRect(
  dropList: CdkDropList,
  x: number,
  y: number
) {
  const {
    top,
    bottom,
    left,
    right
  } = dropList.element.nativeElement.getBoundingClientRect();
  return y >= top && y <= bottom && x >= left && x <= right;
}
